import { render, staticRenderFns } from "./SiftText.vue?vue&type=template&id=54d8f84f&scoped=true&"
import script from "./SiftText.vue?vue&type=script&lang=js&"
export * from "./SiftText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d8f84f",
  null
  
)

export default component.exports